import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';
import { ICMS_GROUP_ADDITIONAL_ID } from '../../catalog/config/component.config';
import { CUSTOMER_GROUPS, customerGroupVisibilityCmsField } from './customer-groups';
import { CustomerGroupsService } from './customer-groups.service';

ICmsContentService.registerComponentMetaPatch((meta: NICmsContentComponent.IMeta) => {
    // styles are only for non-block components
    if (!meta.block) {
        meta.fields.push({
            ...customerGroupVisibilityCmsField(CUSTOMER_GROUPS),
            key: `${ICMS_GROUP_ADDITIONAL_ID}.visibility`,
            group: ICMS_GROUP_ADDITIONAL_ID
        });
    }
});

export function provideCustomerGroups(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(CustomerGroupsService).appInitializer();
        })
    ]);
}
